import { useParams } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { ProfileContext } from "../contexts/profileContext";
import { PageWrapper } from "../components/admin";
import OrgServices from "../components/admin/organization/sevices/orgServices";

export default function OrganisationServices() {
  const [profile] = useContext(ProfileContext);
  const [org, setOrg] = useState(null);

  const { orgId, service } = useParams();
  const { organizations } = profile;

  useEffect(() => {
    if (!orgId || !organizations?.length) return;
    const org = organizations.find((org) => org._id === orgId);
    if (!org) return;

    setOrg({ ...org });
  }, [orgId, organizations]);

  return (
    <div>
      <PageWrapper pageHeading={"Organisation Services"}>
        <OrgServices org={org} service={service} />
      </PageWrapper>
    </div>
  );
}
